module.exports = __webpack_public_path__ + "static/media/paymongo-green.d8ad82f2.png";